export function jqModal() {

  jQuery(function () {

    //bodyのスクロール位置の格納
    var state = false;
    var scrollpos;

    //is-fixedの制御
    function swichFixed() {
      if (state == false) {
        scrollpos = $(window).scrollTop()
        $('body').addClass('is-fixed').css({ 'top': -scrollpos })
        state = true;
      } else {
        $('body').removeClass('is-fixed').css({ 'top': 0 }),
          window.scrollTo(0, scrollpos)
        state = false;
      }
    }

    // モーダルを開く
    $(document).on('click', '.js-modalOpen', function() {
      var target = $(this).data('modal-content');
      var modal = $('#' + target);
      modal.fadeIn(300);
      swichFixed();
    });

    // モーダルを閉じる（オーバーレイと閉じるボタン）
    $(document).on('click', '.js-modalClose', function() {
      $(this).closest('.c-modal').fadeOut(300);
      $('iframe').each(function() {
        var src = $(this).attr('src');
        $(this).attr('src', src);
      });
      swichFixed();
    });

  });

}

/** 

HTMLサンプル

<div class="js-modalOpen" data-modal-content="modal_01"></div>

<div class="c-modal" id="modal_01">
  <div class="c-modal_body">
    <div class="c-modal_content">
      <p>コンテンツが入ります。</p>
    </div>
    <div class="c-modal_close js-modalClose"></div>
  </div>
  <div class="c-modal_overlay js-modalClose"></div>
</div>
**/